import { render, staticRenderFns } from "./serviceProviderJoining.vue?vue&type=template&id=5e366f64&scoped=true"
import script from "./serviceProviderJoining.vue?vue&type=script&lang=js"
export * from "./serviceProviderJoining.vue?vue&type=script&lang=js"
import style0 from "./serviceProviderJoining.vue?vue&type=style&index=0&id=5e366f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e366f64",
  null
  
)

export default component.exports